import { mapState } from 'vuex'

export default {
	computed: {
        ...mapState([
			'ready',
			'auth',
			'user',
			'userTeam',
			'userTeams',
			'translations',
			'showExpirationDialog',
			'showPlanLimitDialog'
		])
	}
}
